<template>
  <div>
    <ok-modal
      :value="value"
      size="md"
      :title="$t('users.switch-account')"
      @change="close()"
    >
      <sub-account
        v-for="subAccount in subAccounts"
        :key="subAccount.sub_account.id"
        :sub-account="subAccount"
        @switch="(payload) => switchAccount(payload)"
        @delete="deleteSubAccount(subAccount)"
      />
      <div class="footer">
        <div
          class="add-new-account-label"
          @click="openAddNewAccount"
        >
          <span>{{ $t('users.add-new-account') }}</span>
        </div>
      </div>

    </ok-modal>
    <add-new-account-popup
      :value="showAddNewAccount"
      :default-email="defaultEmail"
      @close="closeAddNewAccountPopUp()"
    />

  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import AddNewAccountPopup from '@/views/admin/user/AddNewAccountPopup'
import SubAccount from '@/views/admin/user/SubAccount'
import OkModal from '@/@okmenu/components/modals/OkModal'
import StorageService from '@/services/storage-service'

export default {
  name: 'SwitchAccountPopup',
  components: {
    SubAccount, AddNewAccountPopup, OkModal,
  },
  props: {
    value: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showAddNewAccount: false,
      defaultEmail: null,
    }
  },
  computed: {
    ...mapGetters({
      subAccounts: 'auth/subAccounts',
      mainAccount: 'auth/mainAccount',
      user: 'auth/user',
    }),
  },

  methods: {
    openAddNewAccount() {
      this.showAddNewAccount = true
      this.close()
    },
    close() {
      this.$emit('close')
    },
    closeAddNewAccountPopUp() {
      this.showAddNewAccount = false
    },
    switchAccount(payload) {
      this.$store.dispatch('auth/SWITCH_ACCOUNT', payload)
        .then(res => {
          const { user } = res
          this.close()
          this.$notifySuccess(this.$t('auth.welcome-back-user', [user.name]))
          const pendingRoute = StorageService.getItem('okmenu_route_after_auth', null, -1)
          this.$router.push(pendingRoute ?? { name: 'admin:home' }).catch(() => {})
        })
        .catch(err => {
          this.$notifyError(err)
          this.error = err
        })
    },
    deleteSubAccount(subAccount) {
      this.$store.commit('auth/SET_SUBACCOUNTS', this.subAccounts.filter(sub => sub.id !== subAccount.id))
    },
  },
}
</script>

<style lang="scss" scoped>
.spinner-block{
    text-align:center;
    margin: 0 auto;
    width:100%;
}
 .footer{
     display: flex;
     justify-content: center;
     flex-direction: column;
     align-items: center;
     margin-top: 2rem;
     gap: 1rem;
     span{
         cursor: pointer;
         text-transform: capitalize;
         text-decoration: underline;
     }
 }
</style>
